import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const PortalToolbar = ({ handleTab, currentTab }) => {
  const { t } = useTranslation(['notifications-portal'])
  return (
    <nav className="ctp-toolbar-menu">
      <ul>
        <li>
          <a
            className={currentTab === 'all' ? 'is-active' : ''}
            onClick={() => (currentTab === 'all' ? null : handleTab('all'))}
          >
            <span>{t('notifications-portal:toolbar.generalTab')}</span>
          </a>
        </li>
        <li>
          <a
            className={currentTab === 'package' ? 'is-active' : ''}
            onClick={() => (currentTab === 'package' ? null : handleTab('package'))}
          >
            <span>{t('notifications-portal:toolbar.personalTab')}</span>
          </a>
        </li>
      </ul>
    </nav>
  )
}

PortalToolbar.propTypes = {
  handleTab: PropTypes.func,
  currentTab: PropTypes.string,
}

export default PortalToolbar
